// various helpers for working with scoring criteria, nesting and unnesting

import groupBy from 'lodash/groupBy';
import partition from 'lodash/partition';


var buildNestedCriteria = function(flatCriteriaArray) {
    // takes flat array of criteria objects (likely from API) and outputs object with 2 keys:  requirements: [Array of req criteria], scoring: [Array of scoring criteria groups with nested items]
    // use object descructuring to get return value from 2 keys
    let prepped = flatCriteriaArray.map(raw => {  // do prep work on raw values from API to make them easier to manage here
        let prep = Object.assign({}, raw);  // create new object to work with
        if (prep.parent === null && !prep.is_requirement && !prep.is_parent) {
            console.warn('FOUND ONE THAT SHOULD BE is_parent BUT IS NOT');
            console.warn(prep);
        }
        if (prep.parent === null) {  // this will be for top-level things and requirements
            prep.parent = 'parent';  // for top-level criteria & requirements, we'll replace 'null' with 'parent' so easier to work with
        }
        prep.existing = true;  // mark these as existing so you know not to mess with their IDs when prepping to send back
        return prep
    });
    let separated = partition(prepped, function(crit) { return crit.is_requirement; }); // returns array of 2 arrays --> array[0] are criteria where is_requirement is true, array[1] are criteria where false (scoring criteria)
    let reqCriteria = separated[0];  // array of objects, should be ready to go as our requirements list/array
    let scoreCriteria = separated[1];  // flat array of scoring criteria, still needs to be nested
    let groupedScoring = groupBy(scoreCriteria, function(sc) { return sc.parent} );  // returns object of items grouped by parent id.  keys are parent ID, values are arrays of objects that share that parent ID
    console.log('from our buildNestedCriteria function, requirement criteria is:');
    console.log(reqCriteria);
    console.log('grouped scoring criteria is');
    console.log(groupedScoring);
    let parentGroups = groupedScoring['parent'];  // pulls out array of parent groups only (not yet nested)
    console.log(parentGroups);
    // now go through parent groups, find their array of child items and add them as nested items
    // must make sure you do this in way that Vue will be reactive on new object property 'items'
    let nestedScoringArray = parentGroups.map(parent => {  // returns a NEW array that is nested
        let parentNested = {...parent};  // start with this, which is safe because parent is not YET nested
        parentNested.items = groupedScoring[parent.id];  // get the array of nested items from results of groupBy function & store as nested on parent
        // CHECK THAT IT IS REACTIVE, OTHERWISE USE vm.$set()
        return parentNested;
    });  // this is our built-up nested scoring criteria... now we just set it to correct data property
    console.log('fully built nested array below');
    console.log(nestedScoringArray);
    // now set our output / return object
    let returnObj = {
        requirements: reqCriteria,
        scoring: nestedScoringArray,
    }
    return returnObj;
}


export {
    buildNestedCriteria,
}